module.exports = __webpack_public_path__ + "img/wxCode.2564e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wxCode.png
// module id = oRQ6
// module chunks = 0